module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen1.74965a10.jpg";